import { render, staticRenderFns } from "./Grid_1_6.vue?vue&type=template&id=0a54a180&"
import script from "./Grid_1_6.vue?vue&type=script&lang=ts&"
export * from "./Grid_1_6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports